import React from 'react';
import { endOfDay, endOfYear, startOfYear } from 'date-fns';

import {
    Container, Grid, FormControl, InputLabel, Select,
    MenuItem
} from "@mui/material";
import TicketPromedio from './TicketPromedio';
import DailyAverageTicket from './DailyAverageTicket';

const TicketPromedioComponent = ({
    year, setYear, averageTicket,
    generalTktGraph, generalTktTable,
    clientTktGraph, clientTktTable,
    orders, customers, today
}) => {
    const selectedYear = Number(year);
    const yearDate = new Date(selectedYear, 0, 1);
    const exportRange = {
        startDate: startOfYear(yearDate),
        endDate: selectedYear === today.getFullYear()
            ? endOfDay(today)
            : endOfYear(yearDate)
    };
    const handleYearChange = ({ target: { value }}) => {
        setYear(value);
    };

    return (
        <Container maxWidth='xl' sx={{ mt: 5 }} className="last-view">
            <FormControl>
                <InputLabel id="year-select-label">Año</InputLabel>
                <Select
                    labelId="year-select-label"
                    id="demo-year-simple-select"
                    value={year}
                    label="Año"
                    onChange={handleYearChange}
                >
                    {
                        averageTicket.map(({ year }) =>
                            <MenuItem key={year} value={year}>{year}</MenuItem>
                        )
                    }
                </Select>
            </FormControl>
            <Grid container spacing={4}>
                <Grid item xl={6} lg={6} md={12} xs={12}>
                    <TicketPromedio
                        tableTitle={'general'}
                        data={generalTktGraph}
                        dataTable={generalTktTable}
                        exportConfig={{
                            reportType: 'average_ticket',
                            range: exportRange,
                            segment: 'general',
                            filename: `pedidos_ticket-promedio_general_${selectedYear}.csv`
                        }}
                    />
                </Grid>
                <Grid item xl={6} lg={6} md={12} xs={12}>
                    <TicketPromedio
                        tableTitle={'clientes nuevos'}
                        data={clientTktGraph}
                        dataTable={clientTktTable}
                        exportConfig={{
                            reportType: 'average_ticket',
                            range: exportRange,
                            segment: 'newCustomers',
                            filename: `pedidos_ticket-promedio_clientes-nuevos_${selectedYear}.csv`
                        }}
                    />
                </Grid>
                <Grid item xs={12}>
                    <DailyAverageTicket
                        year={year}
                        orders={orders}
                        customers={customers}
                        today={today}
                    />
                </Grid>
            </Grid>
        </Container>
    );
};

export default TicketPromedioComponent;
